/** @jsxImportSource @emotion/react */
import React from 'react';
import styled from '@emotion/styled';
import { keyframes, css } from '@emotion/react';
import { rgba } from 'polished';
import * as color from '@constant/color';

interface IProps {
  color?: string;
  size: 'small' | 'medium' | 'large';
}

const SpinAnime = keyframes`
  from {transform: rotate(0deg);}
  to {transform: rotate(360deg);}
`;

const SPINNER_SIZES = {
  small: { diameter: '15px', lineWidth: '2px' },
  medium: { diameter: '30px', lineWidth: '4px' },
  large: { diameter: '50px', lineWidth: '6px' },
} as const;

const Wrapper = styled.div<IProps>`
  ${(props) => {
    const { diameter, lineWidth } = SPINNER_SIZES[props.size];
    const lineColor = props.color || color.BLACK_2;
    return css`
      width: ${diameter};
      height: ${diameter};
      border: ${lineWidth} solid ${rgba(lineColor, 0.2)};
      border-top: ${lineWidth} solid ${lineColor};
      border-radius: 50%;
      animation: ${SpinAnime} 3s infinite linear normal;
    `;
  }}
`;

const Spinner: React.FC<IProps> = ({ size, color }) => {
  return <Wrapper size={size} color={color} />;
};

export default Spinner;
